import React, {useEffect, useState} from 'react';
import '../App.css';
import speaker from '../speaker4.png';
import speaker2 from '../speaker5.png'
import arrow from '../right-arrow.svg'
import arrowRed from '../right-arrow-red.svg'
import {
    Row,
    Col
} from 'bootstrap-4-react';

function Speaker() {



    const speakerM = {
        id: 1,
        photo: speaker,
        name: 'Мария Степанова',
        about: 'специалист по продажам',
        progress: [
            'Работает с основания бренда Sprayplast',
            'Построила с нуля успешный отдел продаж, приносящий прибыль',
            'Самая быстрая продажа в строительную организацию – от первой встречи, до денег на счету 1 неделя',
            'Работает с партнёрами и сетями'
        ]
    }

    const speakerE = {
        id: 2,
        photo: speaker2,
        name: 'Евгений Коркишко',
        about: 'предприниматель, эксперт',
        progress: [
            'Знает все про декоративные покрытия и сопутствующее оборудование',
            '5 лет назад начинал с того, что своими руками выполнял работы, на сегодняшний день основатель материалов Sprayplast и технологии механизированного нанесения декоративных покрытий'
        ]
    }


    const [speakerState, setSpeakerState] = useState(speakerM)
    const [arrowState, setArrowState] = useState(arrow)

    const changeSpeaker = () => {
        if (speakerState.id === 1) {
            setSpeakerState(speakerE)
        }else {
            setSpeakerState(speakerM)
        }
    }

    useEffect(()=>{
        const interval = setInterval(()=>{
            if (speakerState.id === 1) {
                setSpeakerState(speakerE)
            }else {
                setSpeakerState(speakerM)
            }
        }, 7000)
        return ()=> clearInterval(interval)
    })

    return (
        <Row id="sRow">
            <Col col="lg-4">
                <h3 className="rowTitle">Ведущие вебинара</h3>
                <h4 className={'speakerName'}>{speakerState.name}<span className={'arrowSpeaker'} onClick={changeSpeaker} onMouseOver={()=>{setArrowState(arrowRed)}} onMouseLeave={()=>{setArrowState(arrow)}}><img src={arrowState} height={'20'} alt={'arrow'} /></span></h4>
                <h4 className={'speakerName'}><span>{speakerState.about}</span></h4>
                <ul>
                    {
                        speakerState.progress.map((item)=> {
                            return <li key={Math.random()}><span className="blackLi">{item}</span></li>
                        })
                    }

                </ul>
            </Col>
            <Col col="lg-8" id="speakerImgWrap">
                <img id="speakerImg" src={speakerState.photo} alt="ведущий"/>
            </Col>
        </Row>


    );
}

export default Speaker;